import { render, staticRenderFns } from "./removeService.vue?vue&type=template&id=072742ba&scoped=true&lang=pug"
import script from "./removeService.vue?vue&type=script&lang=js"
export * from "./removeService.vue?vue&type=script&lang=js"
import style0 from "./removeService.vue?vue&type=style&index=0&id=072742ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072742ba",
  null
  
)

export default component.exports